import { GatorProtectActionTypes } from './gatorProtect.types';

const gatorProtectLoading = payload => ({ type: GatorProtectActionTypes.GATOR_PROTECT_LOADING, payload });

const listPlansRequest = ({ headerId } = {}) => ({ type: GatorProtectActionTypes.GATOR_PROTECT_LIST_PLANS_REQUEST, payload: { headerId } });
const listPlansSuccess = () => ({ type: GatorProtectActionTypes.GATOR_PROTECT_LIST_PLANS_SUCCESS });
const listPlansFailure = () => ({ type: GatorProtectActionTypes.GATOR_PROTECT_LIST_PLANS_FAILURE });
const listPlansSet = payload => ({ type: GatorProtectActionTypes.GATOR_PROTECT_LIST_PLANS_SET, payload });

const purchaseFastCheckoutRequest = payload => ({
  type: GatorProtectActionTypes.GATOR_PROTECT_PURCHASE_FAST_CHECKOUT_REQUEST,
  payload,
});
const purchaseUpgradeOrderRequest = payload => ({
  type: GatorProtectActionTypes.GATOR_PROTECT_PURCHASE_UPGRADE_ORDER_REQUEST,
  payload,
});
const getPlanDetailsRequest = payload => ({ type: GatorProtectActionTypes.GATOR_PROTECT_GET_PLAN_DETAILS_REQUEST, payload });
const getPlanDetailsSuccess = () => ({ type: GatorProtectActionTypes.GATOR_PROTECT_GET_PLAN_DETAILS_SUCCESS });
const getPlanDetailsFailure = () => ({ type: GatorProtectActionTypes.GATOR_PROTECT_GET_PLAN_DETAILS_FAILURE });
const getPlanDetailsSet = payload => ({ type: GatorProtectActionTypes.GATOR_PROTECT_GET_PLAN_DETAILS_SET, payload });
const setAutoProtect = payload => ({ type: GatorProtectActionTypes.GATOR_PROTECT_SET_AUTO_PROTECT, payload });
const updateAutoProtectRequest = payload => ({ type: GatorProtectActionTypes.GATOR_PROTECT_UPDATE_AUTO_PROTECT_REQUEST, payload });
const setPlanDetailsLoaded = boolean => ({ type: GatorProtectActionTypes.GATOR_PROTECT_SET_PLAN_DETAILS_LOADED, payload: boolean });

const acceptTermsRequest = payload => ({ type: GatorProtectActionTypes.GATOR_PROTECT_ACCEPT_TERMS_REQUEST, payload });
const acceptTermsSuccess = () => ({ type: GatorProtectActionTypes.GATOR_PROTECT_ACCEPT_TERMS_SUCCESS });
const acceptTermsFailure = () => ({ type: GatorProtectActionTypes.GATOR_PROTECT_ACCEPT_TERMS_FAILURE });

const putAcknowledgementRequest = ({ hostingId }) => ({
  type: GatorProtectActionTypes.GATOR_PROTECT_PUT_ACKNOWLEDGEMENT_REQUEST,
  payload: { hostingId },
});
const putAcknowledgementSuccess = () => ({ type: GatorProtectActionTypes.GATOR_PROTECT_PUT_ACKNOWLEDGEMENT_SUCCESS });
const putAcknowledgementFailure = () => ({ type: GatorProtectActionTypes.GATOR_PROTECT_PUT_ACKNOWLEDGEMENT_FAILURE });

const getPlanThreatsRequest = payload => ({ type: GatorProtectActionTypes.GATOR_PROTECT_PLAN_THREATS_REQUEST, payload });
const setPlanThreats = payload => ({ type: GatorProtectActionTypes.GATOR_PROTECT_PLAN_THREATS_SET, payload });
const planThreatsSuccess = () => ({ type: GatorProtectActionTypes.GATOR_PROTECT_PLAN_THREATS_SUCCESS });
const planThreatsFailure = () => ({ type: GatorProtectActionTypes.GATOR_PROTECT_PLAN_THREATS_FAILURE });
const planThreatsLoading = payload => ({ type: GatorProtectActionTypes.GATOR_PROTECT_PLAN_THREATS_LOADING, payload });

const actions = {
  loading: gatorProtectLoading,
  purchase: {
    fastCheckout: {
      request: purchaseFastCheckoutRequest,
    },
    upgradeOrder: {
      request: purchaseUpgradeOrderRequest,
    },
  },
  plans: {
    request: listPlansRequest,
    success: listPlansSuccess,
    failure: listPlansFailure,
    set: listPlansSet,
  },
  planThreats: {
    request: getPlanThreatsRequest,
    success: planThreatsSuccess,
    failure: planThreatsFailure,
    loading: planThreatsLoading,
    set: setPlanThreats,
  },
  planDetails: {
    request: getPlanDetailsRequest,
    success: getPlanDetailsSuccess,
    failure: getPlanDetailsFailure,
    set: getPlanDetailsSet,
    setAutoProtect,
    updateAutoProtect: {
      request: updateAutoProtectRequest,
    },
    loaded: setPlanDetailsLoaded,
  },
  acceptTerms: {
    request: acceptTermsRequest,
    success: acceptTermsSuccess,
    failure: acceptTermsFailure,
  },
  acknowledgement: {
    request: putAcknowledgementRequest,
    success: putAcknowledgementSuccess,
    failure: putAcknowledgementFailure,
  },
};

export default actions;
